export default __webpack_public_path__ + "static/media/pe.935d1c42.svg";